import { CSSProperties, ReactNode } from 'react'
import type { IconName } from '../Icon'
export type AlertKind = 'success' | 'warning' | 'error' | 'info'

export const IconMap: Record<AlertKind, IconName> = {
  success: 'checkCircle',
  warning: 'alertTriangle',
  error: 'alertCircle',
  info: 'alertInfo',
} as const

export type AlertProps = {
  kind: AlertKind
  global?: boolean
  icon?: boolean
  iconKind?: AlertKind
  children?: ReactNode
  size?: 'small' | 'medium'
  className?: string
  style?: CSSProperties
}
